define([
    "jquery",
    "underscore",
    "marionette",
    "behaviors/form_errors_behavior",
    "backbone.syphon"
], function($, _, Marionette, FormErrorsBehavior) {
    return Marionette.View.extend({
        el: '#content_layout',

        behaviors: {
            formErrors: {
                behaviorClass: FormErrorsBehavior
            }
        },

        ui: {
            btnRequestBonus: "#btn_request_bonus",
            btnRequestReset: "#btn_request_reset",

            modalAjax: "#ajax_response_modal",
            modalTitle: "#ajax_response_modal_title",
            modalDesc: "#ajax_response_modal_desc",
            modalBtnOK: "#ajax_response_modal_btn_ok",

            tcFile: '.tc_file',
        },

        events:{
            "click @ui.btnRequestBonus": function (e) {
                e.preventDefault();
                if($(e.target).hasClass('inactive')) {
                    return;
                }
                $(e.target).addClass('inactive'); // dont let them click twice
                this.requestBonus()
            },
            "click @ui.btnRequestReset": function (e) {
                e.preventDefault();
                if($(e.target).hasClass('inactive')) {
                    return;
                }
                $(e.target).addClass('inactive'); // dont let them click twice
                this.requestReset()
            },
            "click @ui.modalBtnOK": function(e) {
                e.preventDefault();
                window.location.href = window.location.href;
                this.ui.modalAjax.modal('hide');
            },
            "click @ui.tcFile": function(e) {
                e.preventDefault();
                const filename = encodeURIComponent("100_Spring_Bonus_TC.pdf");
                const fileUrl = "/assets/common/main/download/promotion/" + filename;
                const currentDomain = window.location.origin;
                const url  = currentDomain + fileUrl
                window.open(url, '_blank');
            }
        },
        
        requestBonus: function() {
            const that = this
            $.ajax("/rest_promotion/spring_bonus_request_bonus", {
                method: "POST",
                success: function (data) {
                    that.ui.modalTitle.text(window.translations.bonus100_success);
                    that.ui.modalDesc.text(data.message);
                    that.ui.modalAjax.modal({ show: true, backdrop: 'static', keyboard: false });
                },
                error: function (xhr, textStatus, errorThrown) {
                    that.ui.modalTitle.text(window.translations.bonus100_fail);
                    that.ui.modalDesc.text(xhr.responseJSON.message);
                    that.ui.modalAjax.modal({ show: true, backdrop: 'static', keyboard: false });
                },
            });
        },

        requestReset: function() {
            const that = this
            $.ajax("/rest_promotion/spring_bonus_request_reset", {
                method: "POST",
                success: function (data) {
                    that.ui.modalTitle.text(window.translations.bonus100_success);
                    that.ui.modalDesc.text(data.message);
                    that.ui.modalAjax.modal({ show: true, backdrop: 'static', keyboard: false });
                },
                error: function (xhr, textStatus, errorThrown) {
                    that.ui.modalTitle.text(window.translations.bonus100_fail);
                    that.ui.modalDesc.text(xhr.responseJSON.message);
                    that.ui.modalAjax.modal({ show: true, backdrop: 'static', keyboard: false });
                },
            });
        },

        initialize: function(){
            this.bindUIElements();
        },
    });
});